import { resourceReducer, getResources } from 'redux-resource';

export default resourceReducer('insuranceContracts');

export const getFiltered = (
  state,
  { 
    subscription = null,
    bypassedSubscription = null,
    quickSubscription = null,
    userId
  }
) => getResources(state, contract => {
  if (subscription) {
    subscription = parseInt(subscription);
  }
  if (bypassedSubscription) {
    bypassedSubscription = parseInt(bypassedSubscription);
  }
  if (quickSubscription) {
    quickSubscription = parseInt(quickSubscription);
  }
  return (contract.subscription === subscription) && 
         (contract.bypassed_subscription === bypassedSubscription) &&
         (contract.quick_subscription === quickSubscription) &&
         (!userId || contract.user_profile === userId);
});
export const getFilteredRequestStatus = (state) => {
  return state.requests && state.requests.getAll && state.requests.getAll.status;
}
export const get = (state, id) => state.resources[id];

export const getInsuredDeviceId = (state, id) => state.meta[id] && state.meta[id].insuredDeviceId;

export const getCreateError = (state) => state.requests.create && state.requests.create.error;
